import { useSyncExternalStore } from 'react';

import type { FeaturePreviewIdValue } from '@/lib/feature-previews/feature-preview-catalog';
import { featurePreviewStore, type FeaturePreviewOptIns } from '@/lib/feature-previews/feature-preview-store';

/** This person's opt-ins, live across tabs of the same origin (`feature-preview-program:preview-opt-ins-stay-client-local`). */
export function useFeaturePreviewOptIns(): FeaturePreviewOptIns {
	return useSyncExternalStore(
		featurePreviewStore.subscribe,
		featurePreviewStore.getSnapshot,
		featurePreviewStore.getSnapshot,
	);
}

/** Whether this person turned the preview on. A preview that is off must render nothing. */
export function useFeaturePreview(id: FeaturePreviewIdValue): boolean {
	return useFeaturePreviewOptIns().has(id);
}
